// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//
import { leaseAgreementModalStyles } from "@guestsupply/App/Components/Cart/LeaseAgreementModal";
import getColor from "@insite/mobius/utilities/getColor";
import { css } from "styled-components";

leaseAgreementModalStyles.contentWrapper = {
    css: css`
        display: flex;
        align-items: center;
        justify-content: space-between;
        padding: 20px;
        margin-top: 20px;
        gap: 12px;
        background-color: ${getColor("common.ui2")};
    `,
};
leaseAgreementModalStyles.agreebuttonStyle = {
    css: css`
        min-width: 110px;
    `,
};
leaseAgreementModalStyles.agreementModalStyle = {
    cssOverrides: {
        modalContent: css`
            &&& {
                padding: 0;
            }
        `,
    },
};
leaseAgreementModalStyles.modalText = {
    css: css`
        padding: 10px 20px 0;
    `,
};
